import { Accordion, Alert, Text } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import type {
  MarketplaceCapability,
  SelectedMarketplaceRequest,
} from "../../types/marketplace";
import { AvailableCapabilityCard } from "./AvailableCapabilityCard";

type AvailableCapabilitiesSectionProps = {
  capabilities: MarketplaceCapability[];
  onSelect: (request: SelectedMarketplaceRequest) => void;
};

export function AvailableCapabilitiesSection({
  capabilities,
  onSelect,
}: AvailableCapabilitiesSectionProps) {
  const { t } = useTranslation();

  return (
    <Accordion
      title={t("marketplace.availableCapabilities")}
      titleAccessory={
        <Text size="sm" tone="subtle">
          {t("marketplace.availableCount", { count: capabilities.length })}
        </Text>
      }
    >
      {capabilities.length === 0 ? (
        <Alert
          tone="informative"
          title={t("marketplace.noAdditionalCapabilitiesTitle")}
        />
      ) : (
        <div className="grid gap-(--spacing-16) md:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((capability) => (
            <AvailableCapabilityCard
              key={capability.id}
              capability={capability}
              onSelect={onSelect}
            />
          ))}
        </div>
      )}
    </Accordion>
  );
}
